import { SearchIcon } from "lucide-react";
import * as React from "react";
import { useForm } from "react-hook-form";
import { SearchModeToggle } from "@/views/drive/search/SearchModeToggle";
import { SearchMode } from "@/views/drive/search/types";

export interface SearchFormInputs {
  query: string;
}

interface FilesSelectTreeSearchProps {
  query: string;
  onSearch: (query: string) => void;
  onClear: () => void;
  searchMode: SearchMode;
  onModeChange: (mode: SearchMode) => void;
}

export const FilesSelectTreeSearch: React.FC<FilesSelectTreeSearchProps> = ({
  query,
  onSearch,
  onClear,
  searchMode,
  onModeChange,
}) => {
  const methods = useForm<SearchFormInputs>({
    defaultValues: { query },
  });

  const { reset } = methods;
  const searchQuery = methods.watch("query");

  React.useEffect(() => {
    reset({ query });
  }, [query, reset]);

  const handleSubmit = ({ query }: SearchFormInputs) => {
    onSearch(query);
  };

  const handleClear = () => {
    methods.reset();
    onClear();
  };

  return (
    <form onSubmit={methods.handleSubmit(handleSubmit)} className="mb-4 flex items-center gap-3">
      <div className="relative flex-grow p-1">
        <input
          type="text"
          {...methods.register("query")}
          placeholder={searchMode === "ai" ? "Ask anything..." : "Search files and folders"}
          className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-4 focus:border-blue-500 focus:outline-none"
        />
        <SearchIcon className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
      </div>

      <SearchModeToggle searchMode={searchMode} onModeChange={onModeChange} />

      <button
        type="submit"
        className="rounded-md bg-desert-sand-700 px-4 py-2 text-white hover:bg-desert-sand-900 focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-opacity-50"
      >
        Search
      </button>
      {searchQuery && (
        <button
          type="button"
          onClick={handleClear}
          className="rounded-md bg-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
        >
          Clear
        </button>
      )}
    </form>
  );
};
